export default {
  content: 'sm:pt-[100px] mt-[50px] sm:pb-0 pb-[75px] bg-color-[#fcf]',
  backgroundTitle: 'font-interBold text-[36px] leading-[44px] text-color-blue mb-[12px] lg:mt-[0] sm:text-center lg:text-center sm:text-[48px] sm:leading-[62px]',
  input: 'flex mx-auto sm:mb-[50px] mb-[20px] w-full max-w-[550px] bg-gray-200 appearance-none border border-color-white rounded-3xl py-3 px-7 text-color-text-grey focus:outline-none focus:border-color-border',
  bgContentWrapper: 'mx-auto sm:px-[5vw] max-w-[1440px] flex flex-col items-center gap-[40px] lg:flex-row lg:justify-around lg:items-start lg:gap-[20px]',
  bgContent: 'flex flex-wrap w-[100%]',
  card: 'shadow-[0px_2px_4px_rgba(0,0,0,0.18)] px-6 py-10 w-[97%] sm:w-[47%] md:w-[30.33%]  m-[1.5%] bg-color-white rounded-xl flex flex-col justify-between',
  cardTitle: 'text-xl font-interSemibold text-color-blue',
  cardDescription: 'mt-3 font-inter text-sm',
  cardButton: 'cursor-pointer rounded-lg font-interMedium px-8 py-2 border border-[#EC6D25] text-[#EC6D25] hover:text-color-white hover:bg-[#EC6D25] w-fit',
  emptyText: 'text-center mx-auto',
};
